import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { ContactProvider } from './contexts/ContactContext';
import { CampaignProvider } from './contexts/CampaignContext';
import { SettingsProvider } from './contexts/SettingsContext';
import { AgentProvider } from './contexts/AgentContext';
import { EmailProvider } from './contexts/EmailContext';
import Layout from './components/Layout/Layout';
import Dashboard from './pages/Dashboard';
import Contacts from './pages/Contacts';
import Campaigns from './pages/Campaigns';
import Agents from './pages/Agents';
import Settings from './pages/Settings';
import Analytics from './pages/Analytics';
import Email from './pages/Email';
import './App.css';

function App() {
  return (
    <Router>
      <SettingsProvider>
        <ContactProvider>
          <CampaignProvider>
            <AgentProvider>
              <EmailProvider>
                <div className="app">
                  <Layout>
                    <Routes>
                      <Route path="/" element={<Dashboard />} />
                      <Route path="/contacts" element={<Contacts />} />
                      <Route path="/campaigns" element={<Campaigns />} />
                      <Route path="/agents" element={<Agents />} />
                      <Route path="/email" element={<Email />} />
                      <Route path="/analytics" element={<Analytics />} />
                      <Route path="/settings" element={<Settings />} />
                    </Routes>
                  </Layout>
                  <Toaster
                    position="top-right"
                    toastOptions={{
                      duration: 4000,
                      style: {
                        background: '#363636',
                        color: '#fff',
                      },
                    }}
                  />
                </div>
              </EmailProvider>
            </AgentProvider>
          </CampaignProvider>
        </ContactProvider>
      </SettingsProvider>
    </Router>
  );
}

export default App;